import { useEventOrganizerQuery } from "~graphql/event-organizers.generated"

export default function useEventOrganizer({ id }: { id?: string | null }) {
    const {
        data,
        loading: isLoading,
        error,
    } = useEventOrganizerQuery({
        variables: { id: id ?? "" },
        skip: !id,
    })
    const eventOrganizer = data?.eventOrganizer ?? null

    return { eventOrganizer, isLoading, error }
}
